import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_pd_cheque_pending_processing_queue_RowClass,  } from "../../../dbschema";

export class PostDatedChequePendingProcessingQueueContainerModel extends BaseContainerModel {
    bl_fi_pd_cheque_pending_processing_queue: bl_fi_pd_cheque_pending_processing_queue_RowClass = new bl_fi_pd_cheque_pending_processing_queue_RowClass();
}
